export const FOOTER_PROVIDERS = [
  {
    "title": "3 Oaks",
    "slug": "3-oaks",
    "logo": "/img/provider-logos-white/3oaksgaming.svg",
    "white": true
  },
  {
    "title": "Adlunam",
    "slug": "adlunam",
    "logo": "/img/provider-logos-white/adlunam.webp",
    "white": true
  },
  {
    "title": "Airdice",
    "slug": "airdice",
    "logo": "/img/provider-logos-white/airdice.webp",
    "white": true
  },
  {
    "title": "Amusnet",
    "slug": "amusnet",
    "logo": "/img/provider-logos-white/amusnet.webp",
    "white": true
  },
  {
    "title": "Aviatrix",
    "slug": "aviatrix",
    "logo": "/img/provider-logos-white/aviatrix.webp",
    "white": true
  },
  {
    "title": "Barbara-bang",
    "slug": "barbara-bang",
    "logo": "/img/provider-logos-white/barbarabang.webp",
    "white": true
  },
  {
    "title": "BetSoft Gaming",
    "slug": "betsoft-gaming",
    "logo": "/img/provider-logos-white/betsoft-gaming.webp",
    "white": true
  },
  {
    "title": "BGaming",
    "slug": "bgaming",
    "logo": "/img/provider-logos-white/bgaming.webp",
    "white": true
  },
  {
    "title": "Big Time Gaming",
    "slug": "big-time-gaming",
    "logo": "/img/provider-logos-white/bigtimegaming.webp",
    "white": true
  },
  {
    "title": "Booming Games",
    "slug": "booming-games",
    "logo": "/img/provider-logos-white/booming-games.webp",
    "white": true
  },
  {
    "title": "CT Interactive",
    "slug": "ct-interactive",
    "logo": "/img/provider-logos-white/ctinteractive.webp",
    "white": true
  },
  {
    "title": "EGT Digital",
    "slug": "egt-digital",
    "logo": "/img/provider-logos-white/egtdigital.webp",
    "white": true
  },
  {
    "title": "Endorphina",
    "slug": "endorphina",
    "logo": "/img/provider-logos-white/endorphina.webp",
    "white": true
  },
  {
    "title": "Evolution",
    "slug": "evolution",
    "logo": "/img/provider-logos-white/evolution.webp",
    "white": true
  },
  {
    "title": "Evoplay",
    "slug": "evoplay",
    "logo": "/img/provider-logos-white/evoplay.webp",
    "white": true
  },
  {
    "title": "Galaxsys",
    "slug": "galaxsys",
    "logo": "/img/provider-logos-white/galaxsys.webp",
    "white": true
  },
  {
    "title": "Habanero",
    "slug": "habanero",
    "logo": "/img/provider-logos-white/habanero.webp",
    "white": true
  },
  {
    "title": "Hacksaw Gaming",
    "slug": "hacksaw-gaming",
    "logo": "/img/provider-logos-white/hacksaw-gaming.webp",
    "white": true
  },
  {
    "title": "Iron Dog Studio",
    "slug": "iron-dog-studio",
    "logo": "/img/provider-logos-white/iron-dog-studio.webp",
    "white": true
  },
  {
    "title": "Microgaming",
    "slug": "microgaming",
    "logo": "/img/provider-logos-white/microgaming.webp",
    "white": true
  },
  {
    "title": "NetEnt",
    "slug": "netent",
    "logo": "/img/provider-logos-white/netent.webp",
    "white": true
  },
  {
    "title": "NoLimit City",
    "slug": "nolimit-city",
    "logo": "/img/provider-logos-white/nolimit-city.webp",
    "white": true
  },
  {
    "title": "PG Soft",
    "slug": "pg-soft",
    "logo": "/img/provider-logos-white/pgsoft.webp",
    "white": true
  },
  {
    "title": "Play'n GO",
    "slug": "play-n-go",
    "logo": "/img/provider-logos-white/playngo.webp",
    "white": true
  },
  {
    "title": "Playnetic",
    "slug": "playnetic",
    "logo": "/img/provider-logos-white/playnetic.webp",
    "white": true
  },
  {
    "title": "Playson",
    "slug": "playson",
    "logo": "/img/provider-logos-white/playson.webp",
    "white": true
  },
  {
    "title": "Pragmatic Play",
    "slug": "pragmatic-play",
    "logo": "/img/provider-logos-white/pragmaticplay.webp",
    "white": true
  },
  {
    "title": "Prospectgaming",
    "slug": "prospectgaming",
    "logo": "/img/provider-logos-white/prospectgaming.webp",
    "white": true
  },
  {
    "title": "Red Rake Gaming",
    "slug": "red-rake-gaming",
    "logo": "/img/provider-logos-white/red-rake-gaming.webp",
    "white": true
  },
  {
    "title": "Red Tiger",
    "slug": "red-tiger",
    "logo": "/img/provider-logos-white/redtiger.webp",
    "white": true
  },
  {
    "title": "Retrogames",
    "slug": "retrogames",
    "logo": "/img/provider-logos-white/retrogames.webp",
    "white": true
  },
  {
    "title": "Ruby Play",
    "slug": "ruby-play",
    "logo": "/img/provider-logos-white/rubyplay.webp",
    "white": true
  },
  {
    "title": "SmartSoft",
    "slug": "smartsoft",
    "logo": "/img/provider-logos-white/smartsoft.webp",
    "white": true
  },
  {
    "title": "Spadegaming",
    "slug": "spadegaming",
    "logo": "/img/provider-logos-white/egaming.webp",
    "white": true
  },
  {
    "title": "Spinomenal",
    "slug": "spinomenal",
    "logo": "/img/provider-logos-white/spinomenal.webp",
    "white": true
  },
  {
    "title": "Spribe",
    "slug": "spribe",
    "logo": "/img/provider-logos-white/spribe.webp",
    "white": true
  },
  {
    "title": "TaDa Gaming",
    "slug": "tada-gaming",
    "logo": "/img/provider-logos-white/tadagaming.webp",
    "white": true
  },
  {
    "title": "Wazdan",
    "slug": "wazdan",
    "logo": "/img/provider-logos-white/wazdan.webp",
    "white": true
  },
  {
    "title": "Yggdrasil",
    "slug": "yggdrasil",
    "logo": "/img/provider-logos-white/yggdrasil.webp",
    "white": true
  }
]
